import Sponsor from "./Sponsor";

const bronzeSponsors: Sponsor[] = []

export default bronzeSponsors;